/**
 * Keeps only origin + path: query strings and fragments can carry emails or tokens
 * (e.g. /login?data=<base64 email>), and GA4 must never receive them.
 */
export function sanitizeGa4Url(url: string | null | undefined, base?: string): string | undefined {
  if (!url) return undefined;
  try {
    const parsed = new URL(url, base);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return undefined;
    return `${parsed.origin}${parsed.pathname}`;
  } catch {
    return undefined;
  }
}

/** True for routes rendered inside the authenticated portal layout. */
export function isGa4TrackedPortalUrl(routerUrl: string | null | undefined): boolean {
  const path = (routerUrl ?? '').split(/[?#]/)[0];
  return path === '/dashboard' || path.startsWith('/dashboard/');
}
